module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.alreadyDecided) ? _c('div', {
    staticClass: "buttonsHolder mt-3 d-flex"
  }, [_c('button', {
    staticClass: "btn action mr-1",
    on: {
      "click": _vm.rejectInvite
    }
  }, [_vm._v("Reject")]), _vm._v(" "), _c('button', {
    staticClass: "btn flexGrow1",
    on: {
      "click": _vm.acceptInvite
    }
  }, [_vm._v("Send commissions")])]) : _vm._e(), _vm._v(" "), (_vm.alreadyDecided) ? _c('div', {
    staticClass: "mt-3"
  }, [(_vm.notification.typeStatus == 401) ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fas fa-times color-6 fs-large"
  }), _vm._v(" "), _c('span', {
    staticClass: "bold darker"
  }, [_vm._v("Rejected")])]) : _vm._e(), _vm._v(" "), (_vm.notification.typeStatus == 402) ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fas fa-check color-3 fs-large"
  }), _vm._v(" "), _c('span', {
    staticClass: "bold darker"
  }, [_vm._v("Commissions Sent")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-79ba0495", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79ba0495"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/notifications/bodyAcceptInvite.vue
// module id = 1409
// module chunks = 0